var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Prop } from 'vue-property-decorator';
import { IHistoryState } from '../../store/HistoryState';
import { Component, VueType } from '../core';
import HistoryItem from './HistoryItem';
let HistoryMod = class HistoryMod extends VueType {
    get hasData() {
        return Boolean(this.mod.ids.length);
    }
    get wind() {
        return `columnname=${this.mod.title}&controlname=${this.mod.type}`;
    }
    render() {
        return (<div class="page_history_mod" v-show={this.hasData} _wind={this.wind}>
                <div class="history_mod_header">
                    <i class="title_route"></i>
                    <span class="history_mod_title">{this.mod.title}</span>
                </div>
                <div>
                    {this.mod.ids.map((item, index) => <HistoryItem id={item} key={item} tabTitle={this.mod.title} tabIdx={this.index} index={index}></HistoryItem>)}
                </div>
            </div>);
    }
};
__decorate([
    Prop()
], HistoryMod.prototype, "mod", void 0);
__decorate([
    Prop()
], HistoryMod.prototype, "index", void 0);
__decorate([
    IHistoryState
], HistoryMod.prototype, "state", void 0);
HistoryMod = __decorate([
    Component
], HistoryMod);
export default HistoryMod;
// columnname=精选_频道推荐区&controlname=v_index_nav
